<template>
  <div class="grid grid-cols-9 items-center gap-3 px-5">
    <Progress v-model="percentage" class="col-span-8"></Progress>
    <div class="text-sm text-gray-500">{{ percentage }}%</div>
  </div>
</template>

<script lang="ts" setup>
import { Progress } from '~/components/ui/progress';

const percentage = ref(0);

// 直接设置进度条百分比
const setPercentage = (value: number) => {
  percentage.value = value;
};

// 定时设置进度条百分比,永远不会超过99,需要手动调用finish
const increase = (incrValue: number, time: number) => {
  let stepTime = Math.max(time / incrValue, 100);
  const cnt = Math.max(Math.floor(time / stepTime), 1);
  const incrPercent = Math.floor(incrValue / cnt);
  let i = 0;
  const intervalId = setInterval(() => {
    percentage.value = Math.min(percentage.value + incrPercent, 99);
    i += 1;
    if (i === cnt) {
      clearInterval(intervalId);
    }
  }, stepTime);
};

const init = () => {
  percentage.value = 0;
};

const finish = () => {
  percentage.value = 100;
};

defineExpose({
  init,
  increase,
  finish,
  setPercentage,
});
</script>
